import { render, staticRenderFns } from "./UiRadioButton.vue?vue&type=template&id=169422a1&scoped=true"
import script from "./UiRadioButton.vue?vue&type=script&lang=js"
export * from "./UiRadioButton.vue?vue&type=script&lang=js"
import style0 from "./UiRadioButton.vue?vue&type=style&index=0&id=169422a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169422a1",
  null
  
)

export default component.exports